import React,{useState} from 'react'
import PublisherModal from './PublisherModal';


const PublisherLists=(props)=>{
   const {publisher,getAllPublishers} = props; 
  const [state, setstate] = useState({
      name:0
  })
 
  const handleClick=()=>{
    setstate({
        name:publisher.name
    })
  }


    return (
      <tr><td>{publisher.id}</td><td>{publisher.name}</td><td> <button style={{marginRight: '10px'}} onClick={()=>{handleClick()}} data-target={publisher.id} className="btn-floating btn-medium blue modal-trigger"><i className="material-icons">edit</i></button> 
     
      {/* <button className="btn-floating btn-medium red modal-trigger" data-target={publisher.id+'del'}><i className="material-icons">delete</i></button> */}
      
      <PublisherModal getAllPublishers={getAllPublishers} name={state.name} Id={publisher.id} /></td></tr>
       
      )
  }
  
export default PublisherLists;